<template>
  <a-modal
    :visible="visible"
    title="Clone Existing Task"
    centered
    ok-text="Clone"
    :confirm-loading="isCloningTask"
    :ok-button-props="{ disabled: !sourceTaskId || !newTaskName.trim() }"
    @ok="handleClone"
    @cancel="handleCancel"
  >
    <a-form layout="vertical">
      <a-form-item label="Select Task to Clone">
        <a-select
          v-model:value="sourceTaskId"
          show-search
          placeholder="Select a task"
          :options="taskOptions"
          :filter-option="filterOption"
          style="width: 100%"
        />
      </a-form-item>

      <a-form-item label="New Task Name">
        <a-input
          v-model:value="newTaskName"
          placeholder="Enter new task name"
          @keydown="(e) => ['/', '\\'].includes(e.key) && e.preventDefault()"
        />
        <small style="color: #888">
          Note: The characters <strong>/</strong> and <strong>\</strong> are not
          allowed.
        </small>
      </a-form-item>

      <a-form-item label="Additional Items to Clone">
        <div class="clone-options">
          <a-checkbox v-model:checked="copyProjector">Projector</a-checkbox>
          <a-checkbox v-model:checked="copyModelFiles">Model Files (latest version only)</a-checkbox>
          <span class="clone-iot-label">IoT Integrations</span>
          <div class="clone-iot-items">
            <a-checkbox v-model:checked="copySignalTower">Signal Tower</a-checkbox>
            <a-checkbox v-model:checked="copyBarcode">Barcode</a-checkbox>
            <a-checkbox v-model:checked="copyOpc">OPC</a-checkbox>
          </div>
        </div>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { getSortedTask } from 'src/utils/task';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'CloneTaskModal',
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
  },
  emits: ['close'],
  inject: ['toast'],
  data() {
    return {
      sourceTaskId: null,
      newTaskName: '',
      copyProjector: false,
      copyModelFiles: false,
      copySignalTower: false,
      copyBarcode: false,
      copyOpc: false,
      isCloningTask: false,
    };
  },
  computed: {
    ...mapGetters(['allTasks']),
    taskOptions() {
      return getSortedTask(this.allTasks);
    },
  },
  methods: {
    ...mapActions(['cloneTaskV2']),
    filterOption(input, option) {
      return option.label.toLowerCase().includes(input.toLowerCase());
    },
    async handleClone() {
      if (!this.newTaskName.trim()) {
        this.toast.error('Please enter a new task name');
        return;
      }
      this.isCloningTask = true;
      const payload = {
        task_id: this.sourceTaskId,
        new_task_name: this.newTaskName.trim(),
        copy_projector: this.copyProjector,
        copy_model_files: this.copyModelFiles,
        copy_signal_tower: this.copySignalTower,
        copy_barcode: this.copyBarcode,
        copy_opc: this.copyOpc,
      };
      const [error] = await this.cloneTaskV2(payload);
      this.isCloningTask = false;
      if (error) return;
      this.toast.success('Task cloned successfully!');
      this.handleCancel();
    },
    handleCancel() {
      this.sourceTaskId = null;
      this.newTaskName = '';
      this.copyProjector = false;
      this.copyModelFiles = false;
      this.copySignalTower = false;
      this.copyBarcode = false;
      this.copyOpc = false;
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
.clone-options {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.clone-options :deep(.ant-checkbox-wrapper) {
  margin-left: 0;
  margin-inline-start: 0;
}
.clone-iot-label {
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
}
.clone-iot-items {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
</style>
